import { render, staticRenderFns } from "./AgingRangesForm.vue?vue&type=template&id=16293fc1&scoped=true&"
import script from "./AgingRangesForm.vue?vue&type=script&lang=js&"
export * from "./AgingRangesForm.vue?vue&type=script&lang=js&"
import style0 from "./AgingRangesForm.vue?vue&type=style&index=0&id=16293fc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16293fc1",
  null
  
)

export default component.exports